import { debounce } from "@/plugins/utils";

export default {
  data() {
    return {
      tableHeight: null,
    };
  },
  mounted() {
    this.__resizeHanlder = debounce(() => {
      if (this.$refs.tableList) {
        let height = this.$refs.tableList.$el.parentElement.clientHeight;
        this.tableHeight = `${height}px`;
      }
      if (this.$refs["chart"] && this.chart) {
        this.chart.resize();
      }
    }, 50);
    window.addEventListener("resize", this.__resizeHanlder);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.__resizeHanlder);
  },
  activated() {
    if (this.$refs.tableList) {
      let height = this.$refs.tableList.$el.parentElement.clientHeight;
      this.tableHeight = `${height}px`;
    }
    window.addEventListener("resize", this.__resizeHanlder);
  },
  deactivated() {
    window.removeEventListener("resize", this.__resizeHanlder);
  },
};
